import React from 'react';

import {
  Tooltip
} from "@mui/material";
import { makeStyles } from "@utilities/theme_utilities";

import { 
  Psychic, 
  Force,
  Poison,
  Acid,
  Radiant,
  Cold,
  Fire,
  Lightning,
  Thunder,
  Healing,
  Necrotic,
  Bludgeoning,
  Piercing,
  Slashing,
  Psychic_White, 
  Force_White,
  Poison_White,
  Acid_White,
  Radiant_White,
  Cold_White,
  Fire_White,
  Lightning_White,
  Thunder_White,
  Healing_White,
  Necrotic_White,
  Bludgeoning_White,
  Piercing_White,
  Slashing_White,
  Circle
} from "@models/Images";

interface Props {
  image: string;
  size?: number;
  color?: string;
}

export default function ImageFromString({ 
  image,
  size = 10,
  color = "black",
}: Props) {

  const useStyles = makeStyles()((theme) => {
    if (theme.palette.mode === "dark") {
      return ({
        root: {
            filter: "brightness(0) invert(1)"
        },
      });
    } 
    return ({
      root: {
      },
    });
  });

  const { classes, cx } = useStyles();
  let the_image = "";
  switch(image) {
    case "Bludgeoning": 
      the_image = color === "white" ? Bludgeoning_White : Bludgeoning; 
    break;
    case "Piercing": 
      the_image = color === "white" ? Piercing_White : Piercing; 
    break;
    case "Slashing": 
      the_image = color === "white" ? Slashing_White : Slashing; 
    break;
    case "Psychic": 
      the_image = color === "white" ? Psychic_White : Psychic; 
    break;
    case "Force": 
      the_image = color === "white" ? Force_White : Force; 
    break;
    case "Poison": 
      the_image = color === "white" ? Poison_White : Poison; 
    break;
    case "Acid": 
      the_image = color === "white" ? Acid_White : Acid; 
    break;
    case "Radiant": 
      the_image = color === "white" ? Radiant_White : Radiant; 
    break;
    case "Cold": 
      the_image = color === "white" ? Cold_White : Cold; 
    break;
    case "Fire": 
      the_image = color === "white" ? Fire_White : Fire; 
    break;
    case "Lightning": 
      the_image = color === "white" ? Lightning_White : Lightning; 
    break;
    case "Thunder": 
      the_image = color === "white" ? Thunder_White : Thunder; 
    break;
    case "Healing": 
      the_image = color === "white" ? Healing_White : Healing; 
    break;
    case "Max HP": 
      the_image = color === "white" ? Healing_White : Healing; 
    break;
    case "Temp HP": 
      the_image = color === "white" ? Healing_White : Healing; 
    break;
    case "Necrotic": 
      the_image = color === "white" ? Necrotic_White : Necrotic; 
    break;
    case "Circle": 
      the_image = Circle;
    break;
  }
  if (the_image === "") {
    return null;
  } else {
    return (
      <Tooltip title={image}>
        <img src={the_image} alt={image} 
          className={cx(classes.root, "")} 
          style={{
            width: `${size}px`,
            height: `${size}px`
          }} 
        />
      </Tooltip>
    );
  }
}
